import styled from 'styled-components/native';

import Text from '@components/Text';

export const Container = styled.View`
  min-height: 78px;
`;

export const Button = styled.TouchableOpacity`
  align-items: center;
`;

export const ButtonCircle = styled.View`
  width: 50px;
  height: 50px;
  align-items: center;
  justify-content: center;
  border-radius: 25px;
  border-width: 0;
  background: ${props => props.color ?? props.theme.colors.base.slot1};
`;

export const ButtonImage = styled.Image`
  width: 6px;
  height: 10px;
`;

export const ButtonText = styled(Text)`
  font-size: 12px;
  font-family: ${props => props.theme.fonts.weight[500]};
  color: ${props => props.color ?? props.theme.colors.base.slot1};
  margin-top: 14px;
  text-align: center;
`;
